<h1 mat-dialog-title>Exit</h1>
<div mat-dialog-content>
    <p>A draft for this claim cannot be created. The following fields required for a draft are blank or contain an invalid value:</p>
    <ul class="mt-3 mb-3">
        <li *ngFor="let field of data.fields">- {{ field }}</li>
    </ul>
    <p>Do you want to exit without creating a draft?</p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button class="action-button yes-button" (click)="onYesClick()">Yes</button>
    <button mat-raised-button (click)="onNoClick()">No</button>
</div>